module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#ch01"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("It was a place of cheap magic.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2#ch02"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WO")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Before the empires, before history, there was the Dreamtime.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter3#ch03"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("His people thought honour meant something. Until betrayal rode in…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The city stood in a wide valley between low, black…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("‘Eithne?’ Serrah whispered.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IX")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Rain lashed Bhealfa’s eastern region all through the night. But…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EVEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("They saw a bird, flying low and fast, wings beating…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("As far as they could tell, no one saw them…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("INE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Serrah Ardacris didn’t care.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The first glimmer of dawn. Sunlight lanced through the canopy…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LEVEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Dulian Karr said, ‘I’ll tell you what really happened.’")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WELVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Kutch’s night visitor must have left the hut’s door ajar,…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HIRTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Jecellam, the capital of Rintarah, sprawled in the middle of…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OURTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("There had been a deluge of tears, naturally.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IFTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("By law and convention, Bhealfa’s capital was deemed to be…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IXTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("In the centre of Valdarr the structures of the old…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EVENTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("‘Are you sure you’ll not take some wine?’ Karr said,…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IGHTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The girl began to mutate before their eyes.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("INETEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("‘It’s time you kept your half of the bargain and…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WENTY")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The new arrivals rolled back their hoods and doffed their…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WENTY")]), _vm._v("-O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("A lot happened in the course of the next few…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WENTY")]), _vm._v("-T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WO")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("A fiery streak sliced the heavens. It could have been…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WENTY")]), _vm._v("-T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Anybody noticing them would assume they were siblings running an…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_24"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WENTY")]), _vm._v("-F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("There were fires all over the plains, reddening the night…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_25"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WENTY")]), _vm._v("-F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("It was said that, outside of the empires, the paladin…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_26"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WENTY")]), _vm._v("-S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IX")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("By mid-morning Valdarr was warm and sunny. The few clouds…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_27"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WENTY")]), _vm._v("-S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EVEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Freedom Day celebrations, albeit reluctantly for a goodly segment of…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_28"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WENTY")]), _vm._v("-E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The barbcat raced towards them with eyes blazing and slavering…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_29"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WENTY")]), _vm._v("-N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("INE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Caldason and Serrah were less than halfway through the tunnel…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_30"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HIRTY")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The panicked, driverless team of horses broke into a full…")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/copyright#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COPYRIGHT")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "atp_1"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/aboutthepublisher#atp1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE PUBLISHER")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0